import React from "react";
import SubscribeFormInfoCard from "components/SubscribeFormInfoCard/SubscribeFormInfoCard";
import CruiseRecap from "components/CruiseInfoSummary/CruiseRecap";
import PriceFromBox from "components/PriceFromBox/PriceFromBox";
import PricePromos from "components/PriceFromBox/PricePromos";
import {
  getCardSummaryContent,
  RemoteCruiseCardContent,
  RemoteCruiseCardContent_Suite
} from "../../templates/RequestAQuote/utils";
import { Trans } from "@lingui/macro";
import * as styles from "./CruiseCardSummary.module.scss";
import { LocationSpecificOffer } from "components/useLocationSpecificOffers/types";
import { CruisePriceFrom } from "types/api/suite_price";

interface CruiseCardSummaryProps {
  cruise?: RemoteCruiseCardContent["cruise"];
  specialVoyage?: RemoteCruiseCardContent["specialVoyage"];
  suite?: RemoteCruiseCardContent_Suite;
  price: CruisePriceFrom;
  offers: LocationSpecificOffer[];
}

const CuiseCardSummary: React.FC<CruiseCardSummaryProps> = ({
  cruise,
  specialVoyage,
  suite,
  price,
  offers
}) => {
  const ship = (cruise || specialVoyage)?.data?.ship;
  const { title, image } = getCardSummaryContent(cruise, specialVoyage);

  const content = (
    <React.Fragment>
      {(cruise || specialVoyage) && (
        <div>
          {suite && (
            <div className={styles.suiteName}>
              {suite.category?.name?.localized}
            </div>
          )}
          <br />
          <CruiseRecap
            shipName={ship?.name}
            departureDate={(cruise || specialVoyage)?.data?.departureDate}
            duration={(cruise || specialVoyage)?.data?.days}
          />
          <br />
          <PriceFromBox price={price}>
            <PricePromos offers={offers} variant="list" />
            <div className={styles.disclaimer}>
              <Trans>Fares shown are per Guest</Trans>
            </div>
          </PriceFromBox>
        </div>
      )}
    </React.Fragment>
  );

  return (
    <SubscribeFormInfoCard image={image} title={title} content={content} />
  );
};

export default CuiseCardSummary;
